var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommunityTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_92_1129)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_92_1129",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 44,
    height: 44
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 0H0V44H44V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_92_1129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.8973 5.98889e-05C16.0804 0.0272059 10.5109 2.35703 6.40731 6.47989C2.30369 10.6027 -6.33399e-05 16.183 1.30613e-09 22C1.30614e-09 27.8348 2.31785 33.4306 6.44365 37.5564C10.5694 41.6821 16.1652 44 22 44C27.8348 44 33.4306 41.6821 37.5564 37.5564C41.6821 33.4306 44 27.8348 44 22C44 16.1653 41.6821 10.5695 37.5564 6.4437C33.4306 2.3179 27.8348 5.98889e-05 22 5.98889e-05C21.9657 -1.9963e-05 21.9316 -1.9963e-05 21.8973 5.98889e-05ZM30.9943 13.2441C31.1777 13.2404 31.5828 13.2862 31.8468 13.5007C32.0223 13.653 32.1341 13.8657 32.1603 14.0966C32.1897 14.2671 32.2263 14.6576 32.197 14.9619C31.867 18.4415 30.4333 26.8822 29.7037 30.778C29.3957 32.428 28.7888 32.9799 28.2003 33.033C26.9243 33.1522 25.9545 32.1897 24.717 31.3794C22.781 30.1089 21.6865 29.3187 19.8073 28.0794C17.6348 26.6494 19.0428 25.861 20.2803 24.5777C20.6048 24.2404 26.2332 19.1199 26.3432 18.656C26.356 18.5974 26.3688 18.381 26.2405 18.2674C26.1122 18.1537 25.9215 18.1922 25.784 18.2234C25.5897 18.2674 22.4968 20.3134 16.5055 24.3559C15.6255 24.9609 14.8317 25.2542 14.1185 25.2359C13.3338 25.2212 11.8232 24.794 10.6993 24.4292C9.32069 23.98 8.22619 23.7435 8.3215 22.9827C8.371 22.5867 8.91731 22.1815 9.95869 21.7672C16.3717 18.9732 20.647 17.1307 22.7883 16.2415C28.897 13.7006 30.1675 13.2587 30.9943 13.2441Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_92_1129"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunityTelegram);
export default __webpack_public_path__ + "static/media/community_telegram.45a93080a2834729b1a0d53f8f9b304f.svg";
export { ForwardRef as ReactComponent };